import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Paper,
  Alert,
  Grid,
} from "@mui/material";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { BASE_URL } from "../constants";

const ForgotPassword = () => {
  const location = useLocation();
  const [loginData, setLoginData] = useState(() => {
    const state = location.state || {};
    const userIdParts = state.userId ? state.userId.split("-") : [];
    return {
      stateCode: state.stateCode || userIdParts[0] || "",
      orgCode: state.orgCode || userIdParts[1] || "",
      userCode: state.userCode || userIdParts[2] || "",
      orgEmail: state.orgEmail || state.email || "",
    };
  });
  const [error, setError] = useState("");

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const validateForm = () => {
    const newErrors = {};

    if (!loginData.stateCode.length) {
      newErrors.stateCode = "Please enter state code";
    }
    if (!loginData.orgCode.length) {
      newErrors.orgCode = "Please enter org code";
    }
    if (!loginData.userCode.length) {
      newErrors.userCode = "Please enter user code";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    const otpCred = {
      userId: `${loginData.stateCode}-${loginData.orgCode}-${loginData.userCode}`,
      // email: loginData.orgEmail,
    };
    if (validateForm()) {
      setLoading(true);
      try {
        const response = await fetch(`${BASE_URL}api/user/common/send-otp`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(otpCred),
          // credentials: "include", Include cookies in the request
        });

        const data = await response.json();
        console.log(data);
        if (data.success) {
          alert(data.message);
          navigate("/common/verify-otp", {
            state: {
              StateCode: loginData.stateCode,
              OrgCode: loginData.orgCode,
              UserCode: loginData.userCode,
              OrgEmail: data.email,
            },
          });
        } else {
          setError(data.message);
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong! Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Paper elevation={3} sx={{ padding: 4, maxWidth: 400, width: "100%" }}>
        <Typography variant="h4" align="center" gutterBottom>
          Forgot Password
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <form onSubmit={handleSendOtp}>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={4}>
              <TextField
                fullWidth
                margin="normal"
                label="State Code"
                variant="outlined"
                type="number"
                name="stateCode"
                value={loginData.stateCode}
                onChange={handleChange}
                error={!!errors.stateCode}
                helperText={errors.stateCode}
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Org Code"
                variant="outlined"
                type="number"
                name="orgCode"
                value={loginData.orgCode}
                onChange={handleChange}
                error={!!errors.orgCode}
                helperText={errors.orgCode}
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <TextField
                fullWidth
                margin="normal"
                label="User Code"
                variant="outlined"
                type="number"
                name="userCode"
                value={loginData.userCode}
                onChange={handleChange}
                error={!!errors.userCode}
                helperText={errors.userCode}
              />
            </Grid>
            {/* <Grid item xs={12} lg={12}>
              <TextField
                fullWidth
                margin="normal"
                label="Org Email"
                variant="outlined"
                type="email"
                name="orgEmail"
                value={loginData.orgEmail}
                onChange={handleChange}
                error={!!errors.orgEmail}
                helperText={errors.orgEmail}
              />
            </Grid> */}
          </Grid>
          <Box sx={{ mt: 2, position: "relative" }}>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
              sx={{ fontWeight: "bold", padding: "10px 0" }}
            >
              {loading ? "Sending..." : "Send OTP"}
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  color: "primary.main",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </form>
      </Paper>
    </Box>
  );
};

export default ForgotPassword;
